import { render, staticRenderFns } from "./access-control-badges.vue?vue&type=template&id=6a7d6028&scoped=true&"
import script from "./access-control-badges.vue?vue&type=script&lang=ts&"
export * from "./access-control-badges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7d6028",
  null
  
)

export default component.exports